import { render } from "./RegistrationSpecialities.vue?vue&type=template&id=92f3a5d0&ts=true"
import script from "./RegistrationSpecialities.vue?vue&type=script&lang=ts"
export * from "./RegistrationSpecialities.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__